<template>
  <div class="container">
    <Header />
    <div class="banner">
      <h1>校长信箱</h1>
      <p>PRINCIPAL MAILBOX</p>
    </div>
    <div class="content">
      <div class="messageBox-master">
        <div class="messageForm">
          <form class="form">
            <div class="form-item">
              <label>标题：</label>
              <el-input v-model="formInfo.title" placeholder=""></el-input>
            </div>
            <div class="form-item">
              <label>内容：</label>
              <el-input type="textarea" :rows="5" resize="none" placeholder="" v-model="formInfo.qContent">
              </el-input>
            </div>
            <div class="form-item">
              <label>邮箱：</label>
              <el-input class="telephone" v-model="formInfo.email" placeholder=""></el-input>
              <span>请填写你的邮箱地址，以便回信！</span>
            </div>
            <div class="form-item" style="margin-top:59px">
              <label>验证码：</label>
              <el-input class="code" v-model="formInfo.code" placeholder=""></el-input>
              <canvas class="codeCanvas" id="s-canvas" @click="drawPic" width="138" height="58"></canvas>
            </div>
          </form>
        </div>
        <el-button class="btn" :loading="loading" @click="save">发送邮箱</el-button>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
export default {
  name: 'message',
  data () {
    return {
      formInfo: {
        username: '',
        email: '',
        type: '',
        title: '',
        qContent: '',
        code: ''
      },
      typeList: [
        { name: '招生' },
        { name: '就业' },
        { name: '教学' },
        { name: '学生工作' },
        { name: '生活服务' },
        { name: '人才招聘' },
        { name: '出国留学' },
        { name: '报考问题咨询' }
      ],
      identifyCodes: '1234567890',
      identifyCode: '',
      loading: false,
      messageList: [
        {
          title: '艺体有本科预科吗？',
          createTime: '2021-05-30 14:30:22',
          qcontent: '艺体有本科预科吗？',
          reply: {
            rcontent: '同学您好，我校没有本科预科。'
          }
        },
        {
          title: '艺体有本科预科吗？',
          createTime: '2021-05-30 14:30:22',
          qcontent: '艺体有本科预科吗？',
          reply: {
            rcontent: '同学您好，我校没有本科预科。'
          }
        }
      ],
      currentPage: 1,
      limit: 5,
      total: 0
    }
  },
  components: {
    Header,
    Footer
  },
  mounted () {
    this.drawPic()
    this.getList()
  },
  methods: {
    getList () { // 获取留言列表
      let para = {
        page: this.currentPage,
        rows: this.limit
      }
      this.$http.getMessagesList(para).then(res => {
        console.log(res)
        this.messageList = res.list
        this.total = res.total
        this.currentPage = res.pageNum
      }).catch(err => {
        console.error(err)
      })
    },
    // 生成一个随机数
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 四个数
    makeCode (l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    // 生成一个随机的颜色
    randomColor (min, max) {
      let r = this.randomNum(min, max)
      let g = this.randomNum(min, max)
      let b = this.randomNum(min, max)
      return 'rgb(' + r + ',' + g + ',' + b + ')'
    },
    drawPic () {
      this.identifyCode = ''
      this.makeCode(4)
      let canvas = document.getElementById('s-canvas')
      let ctx = canvas.getContext('2d')
      ctx.textBaseline = 'bottom'
      // 绘制背景
      ctx.fillStyle = 'rgb(78, 0, 114)'
      ctx.fillRect(0, 0, 138, 58)
      // 绘制文字
      for (let i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i)
      }
      this.drawLine(ctx)
      this.drawDot(ctx)
    },
    drawText (ctx, txt, i) {
      ctx.fillStyle = this.randomColor(0, 200)
      ctx.font =
        this.randomNum(35, 45) + 'px SimHei'
      let x = (i + 1) * (138 / (this.identifyCode.length + 1))
      let y = this.randomNum(58, 40)
      var deg = this.randomNum(-40, 40)
      // 修改坐标原点和旋转角度
      ctx.translate(x, y)
      ctx.rotate((deg * Math.PI) / 180)
      ctx.fillText(txt, 0, 0)
      // 恢复坐标原点和旋转角度
      ctx.rotate((-deg * Math.PI) / 180)
      ctx.translate(-x, -y)
    },
    drawLine (ctx) {
      // 绘制干扰线
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = this.randomColor(
          100,
          255
        )
        ctx.beginPath()
        ctx.moveTo(
          this.randomNum(0, 138),
          this.randomNum(0, 58)
        )
        ctx.lineTo(
          this.randomNum(0, 138),
          this.randomNum(0, 58)
        )
        ctx.stroke()
      }
    },
    drawDot (ctx) {
      // 绘制干扰点
      for (let i = 0; i < 40; i++) {
        ctx.fillStyle = this.randomColor(0, 255)
        ctx.beginPath()
        ctx.arc(
          this.randomNum(0, 138),
          this.randomNum(0, 58),
          1,
          0,
          2 * Math.PI
        )
        ctx.fill()
      }
    },
    add () { // 获取更多
      let para = {
        page: this.currentPage + 1,
        rows: this.limit
      }
      this.$http.getMessagesList(para).then(res => {
        console.log(res)
        if (res.list.length > 0) {
          res.list.forEach(element => {
            this.messageList.push(element)
          })
        }
        this.total = res.total
        this.currentPage = res.pageNum
      }).catch(err => {
        console.error(err)
      })
    },
    save () { // 留言
      this.loading = true
      if (this.formInfo.email === '' || this.formInfo.type === '' || this.formInfo.title === '' || this.formInfo.qContent === '' || this.formInfo.code === '') {
        this.$message({
          showClose: true,
          message: '请完善所有信息',
          type: 'error'
        })
        this.loading = false
        return false
      }
      const reg = /^[0-9a-zA-Z_]{0,19}@[0-9a-zA-Z]{1,13}\.[com,cn,net]{1,3}$/
      if (!reg.test(this.formInfo.email)) {
        this.$message({
          showClose: true,
          message: '请输入正确手机号',
          type: 'error'
        })
        this.loading = false
        return false
      }
      if (this.formInfo.code !== this.identifyCode) {
        this.$message({
          showClose: true,
          message: '验证码不正确',
          type: 'error'
        })
        this.loading = false
        return false
      }
      this.$http.createMessage(this.formInfo).then(res => {
        console.log(res)
        if (res.success) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success'
          })
          this.formInfo = {
            name: '',
            telphone: '',
            type: '',
            title: '',
            content: '',
            code: ''
          }
          this.drawPic()
        }
        this.loading = false
      }).catch(err => {
        console.error(err)
        this.loading = false
      })
    }
  }
}
</script>
<style>
/* .messageBox-master .el-input__inner{
  color: gray;
  font-size: 25px;
  line-height: 57px!important;
  height: 57px!important;
}
.el-textarea__inner{
  background: transparent;
  border: none;
  font-size: 25px;
}
.el-icon-arrow-up:before {
  content: "\e6de";
  font-size: 25px;
  line-height: 42px;
  color: #e40a83;
} */
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color: #6e348b;

.banner {
  height: 877px;
  overflow: hidden;
  background: url('../assets/banner.png');
  background-position: left;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #fff;
  justify-content: center;

  h1 {
    margin: 0;
    font-size: 125px;
    // font-weight: bold;
  }

  p {
    font-size: 37px;
    // font-weight: bold;
    width: 500px;
    margin: 0;
  }
}

.content {
  .messageBox-master {
    background: #4e0072;
    color: #fff;
    padding-top: 125px;
    padding-bottom: 130px;

    .btn {
      background: #e4007f;
      color: #fff;
      margin: 62px auto 0;
      display: block;
      width: 208px;
      height: 76px;
      line-height: 76px;
      padding: 0;
      font-size: 25px;
      border-radius: 10px;
      border: none;
    }

    .messageForm {
      background: #f6f2e8;
      width: 1494px;
      color: #717171;
      margin: 0 auto;
      height: 1076px;
      padding: 95px 0 0 105px;

      .form-item {
        display: flex;
        align-items: flex-start;
        line-height: 57px;
        margin-bottom: 38px;

        &.type {
          margin-bottom: 45px;
        }

        label {
          width: 131px;
          font-size: 25px;
        }

        .el-input {
          background: #e2e0dd;
          border-radius: 10px;
          width: 1097px;
          color: #717171;
        }

        .telephone {
          width: 622px;
        }

        span {
          font-size: 25px;
          margin-left: 35px;
          color: #717171;
        }

        .code {
          width: 181px;
          margin-right: 30px;
        }

        .el-textarea {
          background-color: #e2e0dd;
          border-radius: 10px;
          width: 1104px;
          height: 552px;
          margin-bottom: 8px;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .banner {
    height: 477px;
    overflow: hidden;
    background: url('../assets/banner.png');
    background-position: left;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    flex-direction: column;
    // color: #fff;
    justify-content: center;

    h1 {
      margin: 0 auto;
      font-size: 93px;
      // font-weight: bold;
    }

    p {
      font-size: 37px;
      // font-weight: bold;
      width: 100%;
      text-align: center;
      margin: 0 auto;
    }
  }

  .content {
    .messageBox-master {
      background: #4e0072;
      color: #fff;
      padding-top: 75px;
      padding-bottom: 80px;

      .btn {
        background: #e4007f;
        color: #fff;
        margin: 62px auto 0;
        display: block;
        width: 208px;
        height: 76px;
        line-height: 76px;
        padding: 0;
        font-size: 25px;
        border-radius: 10px;
        border: none;
      }

      .messageForm {
        background: #f6f2e8;
        width: 100%;
        color: #717171;
        margin: 0 auto;
        height: auto;
        box-sizing: border-box;
        padding: 95px 0 0 105px;

        .form-item {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          line-height: 57px;
          margin-bottom: 38px;

          &.type {
            margin-bottom: 45px;
          }

          label {
            width: 131px;
            font-size: 25px;
          }

          .el-input {
            background: #e2e0dd;
            border-radius: 10px;
            width: 70%;
            color: #717171;
          }

          .telephone {
            width: 622px;
          }

          span {
            font-size: 25px;
            margin-left: 35px;
            color: #717171;
            margin-left: 130px;
          }

          .code {
            width: 181px;
            margin-right: 30px;
            margin-top: 0px;
          }

          .el-textarea {
            background-color: #e2e0dd;
            border-radius: 10px;
            // width: 1104px;
            width: 70%;
            height: 50%;
            margin-bottom: 8px;
            color: #717171;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .content {
    .messageBox-master {
      background: #4e0072;
      color: #fff;
      padding-top: 75px;
      padding-bottom: 80px;

      .btn {
        background: #e4007f;
        color: #fff;
        margin: 62px auto 0;
        display: block;
        width: 208px;
        height: 76px;
        line-height: 76px;
        padding: 0;
        font-size: 25px;
        border-radius: 10px;
        border: none;
      }

      .messageForm {
        background: #f6f2e8;
        width: 100%;
        color: #717171;
        margin: 0 auto;
        height: auto;
        box-sizing: border-box;
        padding: 95px 0 0 105px;

        .form-item {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          line-height: 57px;
          margin-bottom: 38px;

          &.type {
            margin-bottom: 45px;
          }

          label {
            width: 131px;
            font-size: 25px;
          }

          .el-input {
            background: #e2e0dd;
            border-radius: 10px;
            width: 70%;
            color: #717171;
          }

          .telephone {
            width: 70%;
          }

          span {
            font-size: 25px;
            margin-left: 35px;
            color: #717171;
            margin-left: 130px;
          }

          .code {
            width: 181px;
            margin-right: 30px;
            margin-top: 0px;
          }

          .el-textarea {
            background-color: #e2e0dd;
            border-radius: 10px;
            // width: 1104px;
            width: 70%;
            height: 50%;
            margin-bottom: 8px;
            color: #717171;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/schoolmasterMessage.vue